import { BoxComponent } from '../../../base/box/Box';
import { getScaleSize } from '../../../utils/utils';
import { useNormalizedPixels } from '../../../hooks/useResize';

interface OutOfStockProps {
  scale?: number;
  fontFamily?: string;
}

const OutOfStock = ({ scale = 1, fontFamily = 'sans-serif' }: OutOfStockProps) => {
  const { normalizePixels } = useNormalizedPixels();

  return (
    <BoxComponent
      sx={{
        backgroundColor: '#FF8818',
        color: 'black',
        textAlign: 'center',
        borderRadius: '2.5px',
        padding: '2px 4px',
        marginLeft: '10px',
        fontFamily: fontFamily,
        flexShrink: 0,
        flexGrow: 0,
        fontSize: getScaleSize(normalizePixels(12.5, 'height'), scale),
      }}
    >
      Out of stock
    </BoxComponent>
  );
};

export default OutOfStock;
